/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 15:05:44
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-05-26 16:35:42
 */
import React, { Component } from 'react'
import { Switch, Route, Link } from 'react-router-dom'
import 'antd/dist/antd.css';
// import './index.css'
import { connect } from 'react-redux'
import tx from '../../../statics/suzhou.jpg'
import MyOrder from './components/MyOrder'

import MyProcessOrder from './components/MyProcessOrder'

// import MyCoin from './components/MyCoin'
// import MyLoginLog from './components/MyLoginLog'
// import MyPassword from './components/MyPassword'
import { Layout, Menu, Divider, Avatar } from 'antd';
import {
    UserOutlined,
    ShoppingCartOutlined,
    CopyOutlined,
    StarOutlined,
    SyncOutlined,
    AppstoreOutlined
} from '@ant-design/icons';
import Header4 from '../../Header/Header4';
import Navigator from '../../Navigator';

const { Sider, Content } = Layout;
const { SubMenu } = Menu;
const menudata = [{
    name: '资源下载订单',
    path: '/userresource/myorder'
}, {
    name: '资源预定订单',
    path: '/userresource/MyProcessOrder'
}, {
    name: '资源共享订单',
    path: '/userresource/MyProcessOrder'
}, {
    name: '生产定制订单',
    path: '/userresource/MyProcessOrder'
}, {
    name: '资源操作记录',
    path: '/userresource/myloginlog'
},]
class UserCneter extends Component {
    state = {
        collapsed: false,
    };

    componentDidMount() {
        let path = this.props.location.pathname
        for (let index = 0; index < menudata.length; index++) {
            if (menudata[index].path == path) {
                this.setState({ key: index.toString() })
                return
            }
        }
    }

    render() {
        return (
            <>
                <Header4 />
                <Layout className='usercenter-main'>
                    <Sider trigger={null} width={300} className='usercenter-sider' collapsible collapsed={this.state.collapsed}>
                        <div className='usercenter-sider-panel'>
                            <div className='usercenter-username-panel'>
                                <Avatar className='usercenter-username-avatar' src={tx} ></Avatar>
                                <div className='usercenter-username'>
                                    {this.props.user.userName}
                                </div>
                            </div>
                            <Menu
                                mode="inline"
                                className='usercenter-menu-panel'
                                onSelect={({ key }) => {
                                    this.setState({ key: key.toString() })
                                }}
                                // defaultSelectedKeys={['1']} 
                                selectedKeys={this.state.key} >
                                {menudata.map((data, index) =>
                                    <Menu.Item key={index} className='usercenter-left-menuitem'>
                                        <Link to={data.path}> {data.name}</Link>
                                    </Menu.Item>
                                )}
                                {/* <Menu.Item key="0" className='usercenter-left-menuitem'>
                                    <Link to={'/userresource/myorder'}> 我的订单中心</Link>
                                </Menu.Item>
                                <Menu.Item key="1" className='usercenter-left-menuitem'>
                                    <Link to={'/userresource/myorder'}> 我的订购资源</Link>
                                </Menu.Item>
                                <Menu.Item key="2" className='usercenter-left-menuitem'>
                                    <Link to={'/userresource/mycoin'}>我的上传资源</Link>
                                </Menu.Item>
                                <Menu.Item key="3" className='usercenter-left-menuitem'>
                                    <Link to={'/userresource/myloginlog'}>资源操作记录</Link>
                                </Menu.Item>
                                <Menu.Item key="4" className='usercenter-left-menuitem'>
                                    <Link to={'/userresource/myorder'}>我的生产定制</Link>
                                </Menu.Item>
                                <Menu.Item key="5" className='usercenter-left-menuitem'>
                                    <Link to={'/userresource/mypassword'}>我的检验</Link>
                                </Menu.Item> */}
                            </Menu>
                        </div>
                    </Sider>

                    <Layout className="usercenter-content-layout">
                        <Content className="usercenter-content">
                            <Switch>
                                <Route path='/userresource/myorder' exact component={MyOrder} />
                                <Route path='/userresource/MyProcessOrder' exact component={MyProcessOrder}/>

                            </Switch>
                        </Content>
                    </Layout>



                </Layout>
                <Navigator />
            </>
        )
    }
}

// export default UserCneter
const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({
    login: (userName, password) => {
    }
})

export default connect(mapState, mapDispatch)(UserCneter);